/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {CriterionCodeEnum} from './criterion-code.enum';
import {GlobalSearchCriteriaConfiguration} from '../../../shared/global-search-criteria/configuration/global-search-criteria-configuration';
import {
    SearchCriteriaInputTypeEnum
} from '../../../shared/global-search-criteria/configuration/search-criteria-input-type.enum';
import {CriterionContextCodeEnum} from './criterion-context-code.enum';

export const bundlesGlobalSearchCriteriaConfiguration: GlobalSearchCriteriaConfiguration = {
    criteriaContexts: [
        {
            name: 'Periods',
            code: CriterionContextCodeEnum.PERIODS,
            color: '#E0F2FF',
            criteria: [
                {
                    name: 'Period type',
                    code: CriterionCodeEnum.PERIOD_TYPE,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_MULTI_SELECTION
                },
                {
                    name: 'Time period',
                    code: CriterionCodeEnum.TIME_PERIOD,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_DATE
                },
                {
                    name: 'Total amount',
                    code: CriterionCodeEnum.PERIOD_TOTAL_AMOUNT,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_CURRENCY
                }
            ]
        },
        {
            name: 'Bundles',
            code: CriterionContextCodeEnum.BUNDLES,
            color: '#E5FCEB',
            criteria: [
                {
                    name: 'Bundle number',
                    code: CriterionCodeEnum.BUNDLE_NUMBER,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_TEXT_STRING
                },
                {
                    name: 'Bundle status',
                    code: CriterionCodeEnum.BUNDLE_STATUS,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_MULTI_SELECTION
                }
            ]
        },
        {
            name: 'Settlements',
            code: CriterionContextCodeEnum.SETTLEMENTS,
            color: '#FFF7DE',
            criteria: [
                {
                    name: 'Complaint Number',
                    code: CriterionCodeEnum.COMPLAINT_NUMBER,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_TEXT_NUMBER
                },
                {
                    name: 'Settlement Number',
                    code: CriterionCodeEnum.SETTLEMENT_NUMBER,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_TEXT_NUMBER
                },
                {
                    name: 'Supplier',
                    code: CriterionCodeEnum.SUPPLIER,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_AUTOCOMPLETE_MULTI_SELECTION
                },
                {
                    name: 'Total amount',
                    code: CriterionCodeEnum.SETTLEMENT_TOTAL_AMOUNT,
                    inputTypeSearch: SearchCriteriaInputTypeEnum.INPUT_CURRENCY
                }
            ]
        }
    ]
};
